// Volume units. Base unit: liter.

export type VolumeUnitKey =
  | "ml" | "l" | "cl" | "m3" | "cm3" | "in3" | "ft3"
  | "tsp" | "tbsp" | "floz" | "cup" | "pint" | "quart"
  | "galUS" | "galUK" | "barrel";

export interface VolumeUnit {
  key: VolumeUnitKey;
  en: string;
  bn: string;
  shortEn: string;
  shortBn: string;
  liters: number; // 1 unit = X liters
  note?: { en: string; bn: string };
}

export const VOLUME_UNITS: VolumeUnit[] = [
  { key: "ml",     en: "Milliliter",      bn: "মিলিলিটার",  shortEn: "mL",  shortBn: "মিলি",     liters: 0.001 },
  { key: "cl",     en: "Centiliter",      bn: "সেন্টিলিটার",shortEn: "cL",  shortBn: "সেলি",     liters: 0.01 },
  { key: "l",      en: "Liter",           bn: "লিটার",       shortEn: "L",   shortBn: "লিটার",    liters: 1 },
  { key: "m3",     en: "Cubic Meter",     bn: "ঘনমিটার",     shortEn: "m³",  shortBn: "ঘ.মি",     liters: 1000 },
  { key: "cm3",    en: "Cubic Centimeter",bn: "ঘন সেমি",     shortEn: "cm³", shortBn: "ঘ.সেমি",   liters: 0.001 },
  { key: "in3",    en: "Cubic Inch",      bn: "ঘন ইঞ্চি",    shortEn: "in³", shortBn: "ঘ.ইঞ্চি",  liters: 0.0163871 },
  { key: "ft3",    en: "Cubic Foot",      bn: "ঘনফুট",       shortEn: "ft³", shortBn: "ঘনফুট",   liters: 28.3168 },
  { key: "tsp",    en: "Teaspoon (US)",   bn: "চামচ (US)",   shortEn: "tsp", shortBn: "চামচ",     liters: 0.00492892 },
  { key: "tbsp",   en: "Tablespoon (US)", bn: "টেবিল চামচ",  shortEn: "tbsp",shortBn: "টে.চামচ",  liters: 0.0147868 },
  { key: "floz",   en: "Fluid Ounce (US)",bn: "ফ্লুইড আউন্স",shortEn: "fl oz",shortBn: "ফ্ল.অ.",  liters: 0.0295735 },
  { key: "cup",    en: "Cup (US)",        bn: "কাপ",         shortEn: "cup", shortBn: "কাপ",      liters: 0.236588 },
  { key: "pint",   en: "Pint (US)",       bn: "পাইন্ট",      shortEn: "pt",  shortBn: "পাইন্ট",  liters: 0.473176 },
  { key: "quart",  en: "Quart (US)",      bn: "কোয়ার্ট",    shortEn: "qt",  shortBn: "কোয়ার্ট", liters: 0.946353 },
  { key: "galUS",  en: "Gallon (US)",     bn: "গ্যালন (US)", shortEn: "gal US",shortBn: "গ্যালন US", liters: 3.78541,
    note: { en: "1 US gallon = 3.78541 L (used in USA).", bn: "১ ইউএস গ্যালন = ৩.৭৮৫৪১ লিটার।" } },
  { key: "galUK",  en: "Gallon (UK / Imperial)", bn: "গ্যালন (UK)", shortEn: "gal UK", shortBn: "গ্যালন UK", liters: 4.54609,
    note: { en: "1 Imperial gallon = 4.54609 L (used in UK & Commonwealth).", bn: "১ ইম্পেরিয়াল গ্যালন = ৪.৫৪৬০৯ লিটার (UK ও কমনওয়েলথ)।" } },
  { key: "barrel", en: "Barrel (US oil)", bn: "ব্যারেল (তেল)", shortEn: "bbl", shortBn: "ব্যারেল", liters: 158.987 },
];
